"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Vouchers;
var _react = _interopRequireWildcard(require("react"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _cccisdGraphqlTable = _interopRequireDefault(require("cccisd-graphql-table"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _plusCircle = _interopRequireDefault(require("cccisd-icons/plus-circle"));
var _bin = _interopRequireDefault(require("cccisd-icons/bin"));
var _checkmark = _interopRequireDefault(require("cccisd-icons/checkmark"));
var _copy = _interopRequireDefault(require("cccisd-icons/copy2"));
var _pencil = _interopRequireDefault(require("cccisd-icons/pencil"));
var _cccisdReactRouter = require("cccisd-react-router");
var _cccisdTable = _interopRequireDefault(require("cccisd-table"));
var _Context = _interopRequireDefault(require("../../components/LicensingAdminContext/Context"));
var _query = _interopRequireDefault(require("./query.graphql"));
var _forms = require("./forms.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var Boilerplate = window.cccisd.boilerplate;
var Fortress = window.cccisd.fortress;
function Vouchers() {
  if (!Fortress.hasAnyAccess(['licensing.admin', 'licensing.vouchers'])) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "alert alert-warning"
    }, /*#__PURE__*/_react["default"].createElement("p", null, "You do not have permission to access this page"));
  }
  var _useContext = (0, _react.useContext)(_Context["default"]),
    selectedProduct = _useContext.selectedProduct;
  var location = (0, _cccisdReactRouter.useLocation)();
  if (!(selectedProduct !== null && selectedProduct !== void 0 && selectedProduct.productId)) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "alert alert-warning"
    }, /*#__PURE__*/_react["default"].createElement("p", null, "There are no Licensed Products. Start by\xA0", /*#__PURE__*/_react["default"].createElement(_cccisdReactRouter.Link, {
      to: location.pathname + '#products'
    }, "creating a new Licensed Product"), " before making Vouchers."));
  }
  var columns = [{
    name: 'actions',
    label: 'Actions',
    hideInCsv: true,
    render: function render(_ref) {
      var row = _ref.row,
        loadData = _ref.loadData;
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'flex',
          gap: '4px'
        }
      }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        title: "Edit Voucher Details ".concat(row.transactionDetails && row.transactionDetails.transactionId ? "(Transaction #".concat(row.transactionDetails.transactionId, ")") : ''),
        trigger: /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-xs btn-success"
        }, /*#__PURE__*/_react["default"].createElement(_pencil["default"], null)),
        render: function render(props) {
          return /*#__PURE__*/_react["default"].createElement(_forms.EditVoucherForm, _extends({}, props, {
            voucherId: row.voucherId,
            initialValues: {
              firstName: row['transactionDetails.firstName'],
              lastName: row['transactionDetails.lastName'],
              email: row['transactionDetails.email'],
              phone: row['transactionDetails.phone'],
              notes: row['notes.notes'],
              quantity: row.quantity,
              durationMonths: row.durationMonths || 1,
              useCustomDuration: !!row.durationMonths
            }
          }));
        },
        afterClose: loadData
      }), /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-xs btn-danger",
        onClick: function onClick() {
          (0, _cccisdConfirm["default"])({
            message: 'Are you sure?',
            description: "You are about to delete this voucher (".concat(row.code, ")."),
            confirmLabel: 'Yes',
            abortLabel: 'No'
          }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
            var resp;
            return _regeneratorRuntime().wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  _context.next = 3;
                  return _cccisdAxios["default"]["delete"](Boilerplate.route('licensing.api.voucher.delete', {
                    voucher: row.voucherId
                  }));
                case 3:
                  resp = _context.sent;
                  if (resp.data.status === 'success') {
                    (0, _cccisdNotification["default"])({
                      message: 'Voucher deleted',
                      type: 'success'
                    });
                    loadData();
                  } else {
                    (0, _cccisdNotification["default"])({
                      message: 'Failed to delete voucher',
                      type: 'danger',
                      data: resp.data
                    });
                  }
                  _context.next = 10;
                  break;
                case 7:
                  _context.prev = 7;
                  _context.t0 = _context["catch"](0);
                  (0, _cccisdNotification["default"])({
                    message: 'Failed to delete voucher',
                    type: 'danger'
                  });
                case 10:
                case "end":
                  return _context.stop();
              }
            }, _callee, null, [[0, 7]]);
          })));
        }
      }, /*#__PURE__*/_react["default"].createElement(_bin["default"], null)), row.status === 'Admin Required' && /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        title: "Resolve Voucher Transaction",
        trigger: /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-xs btn-primary"
        }, /*#__PURE__*/_react["default"].createElement(_checkmark["default"], null)),
        render: function render(props) {
          return /*#__PURE__*/_react["default"].createElement(_forms.ResolveVoucherForm, _extends({}, props, {
            voucherId: row.voucherId,
            initialValues: {
              notes: row['notes.notes']
            }
          }));
        },
        afterClose: loadData
      }));
    }
  }, {
    name: 'status',
    label: 'Status',
    filter: true,
    sort: true,
    filterSettings: {
      type: 'selectbox',
      placeholder: '-- select --',
      options: [{
        label: 'Admin Required',
        value: 'Admin Required'
      }, {
        label: 'Resolved',
        value: 'Resolved'
      }, {
        label: 'Purchaser Notified',
        value: 'Purchaser Notified'
      }]
    },
    tooltip: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("strong", null, "Status"), " can be one of the following:", ' '), /*#__PURE__*/_react["default"].createElement("ul", null, /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("strong", null, "Admin Required: "), "Requires additional Admin action before it can be marked as resolved (e.g. ongoing correspondence with a customer).")), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("strong", null, "Resolved: "), "No further action is needed for this voucher.")), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("strong", null, "Purchaser Notified: "), "The customer received an email with their voucher link and no further action is needed.")))),
    render: function render(_ref3) {
      var value = _ref3.value;
      if (value === 'Admin Required') {
        return /*#__PURE__*/_react["default"].createElement("span", {
          className: "badge bg-warning"
        }, value);
      }
      if (value === 'Purchaser Notified') {
        return /*#__PURE__*/_react["default"].createElement("span", {
          className: "badge bg-info"
        }, value);
      }
      if (value === 'Resolved') {
        return /*#__PURE__*/_react["default"].createElement("span", {
          className: "badge bg-success"
        }, value);
      }
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: "badge bg-dark"
      }, value);
    }
  }, {
    name: 'code',
    label: 'Voucher Code',
    filter: true,
    sort: true,
    tooltip: /*#__PURE__*/_react["default"].createElement("div", null, "NOTE: The filter field for this column is intended to search for the code only. Pasting in the full redemption URL will not yield results."),
    render: function render(_ref4) {
      var value = _ref4.value;
      return value && /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-xs",
        onClick: function onClick() {
          var url = Boilerplate.url("/licensing/voucher/redeem/".concat(value));
          navigator.clipboard.writeText(url);
          (0, _cccisdNotification["default"])('Voucher Redemption URL copied!');
        }
      }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_copy["default"], null), /*#__PURE__*/_react["default"].createElement("code", null, value)));
    }
  }, {
    name: 'transactionDetails',
    label: 'Customer Details',
    filter: true,
    sort: true,
    filterSettings: {
      type: 'text',
      fields: ['transactionDetails.firstName', 'transactionDetails.lastName', 'transactionDetails.email']
    },
    render: function render(_ref5) {
      var row = _ref5.row;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", null, row['transactionDetails.firstName'], " ", row['transactionDetails.lastName']), /*#__PURE__*/_react["default"].createElement("div", null, row['transactionDetails.email']));
    }
  }, {
    name: 'transactionDetails.orderId',
    label: 'Order ID',
    filter: true,
    sort: true,
    render: function render(_ref6) {
      var value = _ref6.value;
      return value || '-';
    }
  }, {
    name: 'transactionDetails.transactionId',
    label: 'Transaction ID',
    hideInTable: true,
    render: function render(_ref7) {
      var value = _ref7.value;
      return value || '-';
    }
  }, {
    name: 'redeemed',
    label: 'Redeemed',
    render: function render(_ref8) {
      var row = _ref8.row;
      return row.logList && row.logList.length > 0 ? /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        title: "Voucher Code: ".concat(row.code),
        trigger: /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-xs"
        }, "".concat(row.logList.length, " time").concat(row.logList.length > 1 ? 's' : ''))
      }, /*#__PURE__*/_react["default"].createElement(_cccisdTable["default"], {
        data: row.logList.map(function (v, i) {
          return {
            id: i,
            user: v.pawn.user.fullNameWithUsername,
            createdDate: v.createdDate
          };
        }),
        orderBy: "createdDate",
        columns: [{
          name: 'user',
          label: 'Redeemed By',
          sort: true,
          filter: true
        }, {
          name: 'createdDate',
          label: 'Redeemed At',
          sort: true,
          filter: true,
          filterSettings: {
            type: 'date'
          }
        }]
      })) : '-';
    }
  }, {
    name: 'logList',
    label: 'Last Redeemed At',
    filter: true,
    sort: true,
    filterSettings: {
      type: 'date'
    },
    render: function render(_ref9) {
      var value = _ref9.value;
      return value && value.length > 0 ? value[0].createdDate : '-';
    }
  }, {
    name: 'quantity',
    label: 'Available Licenses',
    filter: true,
    sort: true
  }, {
    name: 'ownedLicenseCount',
    label: 'Active Licenses',
    filter: true,
    sort: true,
    tooltip: /*#__PURE__*/_react["default"].createElement("div", null, "The number of currently active licenses that were redeemed from this voucher specifically. If a license has expired or was renewed/extended, that license will no longer be included in the count.")
  }, {
    name: 'duration',
    label: 'License Duration (months)',
    filter: true,
    sort: true
  }, {
    name: 'notes.notes',
    label: 'Admin Notes',
    filter: true,
    sort: true
  }];
  var tableProps = {
    query: _query["default"],
    columns: columns,
    rowKey: 'voucherId',
    graphqlVariables: {
      productId: selectedProduct.productId
    },
    showDoubleScrollbar: true,
    isStickyHeader: true,
    noRecordsMessage: 'No Vouchers created yet',
    render: function render(renderProps) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "text-right",
        style: {
          marginBottom: 11
        }
      }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        title: "Create New Voucher for ".concat(selectedProduct.label),
        trigger: /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-primary"
        }, /*#__PURE__*/_react["default"].createElement(_plusCircle["default"], {
          spaceRight: true
        }), "Create New Voucher"),
        render: function render(props) {
          return /*#__PURE__*/_react["default"].createElement(_forms.CreateVoucherForm, _extends({}, props, {
            sku: selectedProduct.sku
          }));
        },
        afterClose: renderProps.loadData
      })), renderProps.renderDefault(renderProps));
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_cccisdGraphqlTable["default"], tableProps);
}